import { persistState, Query, Store } from "@datorama/akita";
import { useObservable, useObservableState } from "observable-hooks";
import { debounceTime } from "rxjs/operators";

// ARCH: should be somewhere else
const dateParser = function (key, value) {
  var reISO =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
  if (typeof value === "string") {
    var a = reISO.exec(value);
    if (a) return new Date(value);
  }
  return value;
};

export const localStorage = persistState({
  preStorageUpdateOperator: () => {
    return debounceTime(300);
  },
  deserialize: (a) => {
    const des = JSON.parse(a, dateParser); // WARN: applying dateParser to internal akita objects?
    return { ...des };
  },
  include: ["viewoptions", "notes"],
});

type ColWidthOption = "WIDE" | "MEDIUM" | "COMPACT";
type ColHeightOption = "TALL" | "MEDIUM" | "COMPACT";

export interface ViewOptionsState {
  colWidth: ColWidthOption;
  colHeight: ColHeightOption;
}

function createInitialState(): ViewOptionsState {
  return {
    colWidth: "COMPACT",
    colHeight: "MEDIUM",
  };
}

export class ViewOptionsStore extends Store<ViewOptionsState> {
  constructor() {
    super(createInitialState(), { name: "viewoptions" });
  }
}

export class ViewOptionsQuery extends Query<ViewOptionsState> {
  constructor(protected store: ViewOptionsStore) {
    super(store);
  }
}
export const viewOptionsStore = new ViewOptionsStore();
export const viewOptionsQuery = new ViewOptionsQuery(viewOptionsStore);

export const useViewOptions = () => {
  const viewOptions$ = useObservable(() => viewOptionsQuery.select());
  const viewOptions = useObservableState(viewOptions$);

  return viewOptions;
};

export const useDayHeight = () => {
  const dayHeight$ = useObservable(() =>
    viewOptionsQuery.select((s) => s.colHeight)
  );
  const dayHeight = useObservableState(dayHeight$);
  switch (dayHeight) {
    case "COMPACT":
      return 2000;
    case "TALL":
      return 4400;
    default:
      return 3200;
  }
};

export const useDayWidth = () => {
  const dayWidth$ = useObservable(() =>
    viewOptionsQuery.select((s) => s.colWidth)
  );
  const dayWidth = useObservableState(dayWidth$);
  switch (dayWidth) {
    case "COMPACT":
      return 300;
    case "WIDE":
      return 1300;
    default:
      return 800;
  }
};
